import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainData = styled.div`
  font-size: 11px;
  line-height: 18px;
  color: #31394d;
  font-weight: 500;
`;

export const SubData = styled.div`
  font-size: 11px;
  line-height: 18px;
  color: #748aa1;
  font-weight: 400;
`;

export const LinkMainData = styled(Link)`
  font-size: 11px;
  line-height: 18px;
  color: #0c8ed7;
  font-weight: 500;
  text-decoration: none;
  border: 0;

  &::hover {
    color: #0c8ed7;
    text-decoration: underline;
  }

  &::active {
    color: #0c8ed7;
  }

  &::visited {
    color: #0c8ed7;
  }
`;
